<!--
 * @Author: zyq yqzhang01@gongsibao.com
 * @Date: 2022-08-08 14:55:33
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @LastEditTime: 2022-08-24 17:29:29
 * @FilePath: \fe-frame-page\src\views\enterpriseHighNewN\index.vue
 * @Description: 高新企业测评第二版
-->

<template>
  <div>
    <!--基础版测评 -->
    <base-version v-if="isBase" @onFullVersion="onFullVersion" />
    <!-- 完整版测评 -->
    <full-version v-else :companyName="companyName" />
  </div>
</template>
<script>
import BaseVersion from "./components/baseVersion.vue";
import FullVersion from "./components/fullVersion.vue";
export default {
  name: "enterpriseHigh",
  components: {
    BaseVersion,
    FullVersion,
  },
  data() {
    return {
      isBase: true,
      companyName: "",
    };
  },
  created() {
    const { companyName, type } = this.$route.query;
    if (companyName) {
      this.companyName = companyName;
      this.isBase = false;
    }
    if (type && type == "full") {
      this.isBase = false;
    }
  },
  watch: {
    $route() {
      const { type, companyName } = this.$route.query;
      if (type && type == "full") {
        this.isBase = false;
      } else {
        this.isBase = true;
      }
      if (companyName) {
        this.companyName = companyName;
      }
    },
  },
  methods: {
    onFullVersion(name) {
      this.isBase = false;
      this.companyName = name;
    },
  },
};
</script>
<style lang="less" scoped>
</style>